import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { mergeMap } from 'rxjs/operators';
import { EnvironmentAdapter } from 'src/app/adapters/environment/environment.adapter';
import { HttpAdapter } from 'src/app/adapters/http/http.adapter';
import { MSEndpoint, MSHttpEvent, MSQuery } from 'src/app/adapters/http/utils/http.utils';
import { getBingMapsUrl } from './utils/bing-maps-http.utils';

@Injectable({
  providedIn: 'root'
})
export class BingMapsHttpUseCase {
  constructor(
    private environmentAdapter: EnvironmentAdapter,
    private httpAdapter: HttpAdapter
  ) {}

  private environmentObservable = this.environmentAdapter.getEnvironment();

  /**
   * The function returns an Observable that makes a GET request to a specified endpoint and returns
   * the response in a specified format.
   * @param responseTypeConstructor - The `responseTypeConstructor` parameter is a constructor
   * function that is used to create an instance of the desired response type. It should be a class
   * or a function that can be called with the `new` keyword to create a new instance of the response
   * type.
   * @param endpoint - The `endpoint` parameter is an object that represents the
   * specific endpoint or API route that you want to make a GET request to.
   * @param [query] - The `query` parameter is an optional object that contains additional
   * parameters or filters to be included in the HTTP request. It is used to customize the request
   * and retrieve specific data from the server.
   * @returns an Observable of type `MSHttpEvent.Spec<ResponseType>`.
   */
  get(endpoint: MSEndpoint, query?: MSQuery): Observable<MSHttpEvent.Spec> {
    const getObservable = this.environmentObservable.pipe(
      mergeMap((environment) => {
        const queryWithKey = {
          ...query,
          key: environment.mapConfig.bingMapKey
        };
        const url = getBingMapsUrl(environment.mapConfig.bingMapRestUrl, endpoint);
        const httpGetObservable = this.httpAdapter.get(url, queryWithKey);

        return httpGetObservable;
      })
    );

    return getObservable;
  }
}
